/**
 * Choix d'un port série BZØØK, filtré sur les puces USB du parc.
 *
 * Tous les Masters distribués sont passés par le poste de BZØØK, dont le
 * registre Windows a gardé la trace : CH340, CP210x et CH9102. FTDI est ajouté
 * par précaution, bien qu'aucun Master connu n'en porte : un port de trop dans
 * la liste coûte bien moins cher qu'un Master invisible.
 *
 * Le filtre sert à sortir de la fenêtre de choix les ports Bluetooth associés
 * au PC (« Périphérique Bluetooth (COM5) », ESP32SPP, JL_SPP…) : ils n'ont
 * jamais rien à y faire et noyaient le seul port utile.
 *
 * Il ne dit pas qu'un port EST un Master : une cible ou une carabine branchée
 * en USB porte la même puce. Seule la réponse au PING le confirme, après
 * connexion — c'est déjà ce que fait l'écran Parc.
 *
 * Les TROIS écrans série l'utilisent, Techniciens compris : une carte neuve
 * sort du même parc et porte la même puce, et sur l'écran Techniciens la
 * fenêtre non filtrée proposait aussi les ports Bluetooth du PC. Pour une puce
 * inconnue de la liste, Maj + clic lève le filtre.
 */

type FiltrePort = { usbVendorId: number; usbProductId: number };

export const PUCES_BZOOK: FiltrePort[] = [
  { usbVendorId: 0x1a86, usbProductId: 0x7523 }, // CH340 — DevKit v1 du parc
  { usbVendorId: 0x10c4, usbProductId: 0xea60 }, // CP210x — Silicon Labs
  { usbVendorId: 0x1a86, usbProductId: 0x55d4 }, // CH9102
  { usbVendorId: 0x0403, usbProductId: 0x6001 }, // FTDI FT232 — par précaution
];

/**
 * `sansFiltre` : issue de secours pour une carte montée sur une puce que la
 * liste ignore. Déclenchée par Maj + clic sur le bouton de l'écran.
 */
export function demanderPortBzook(sansFiltre = false): Promise<SerialPort> {
  return navigator.serial.requestPort(
    sansFiltre ? {} : { filters: PUCES_BZOOK }
  );
}
